(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/numbergames-related/assets/components/pay-confirmation.js') >= 0) return;  svs.modules.push('/modules/numbergames-related/assets/components/pay-confirmation.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const fetchAndSummarizeWagers = svs.numbergames_related.utils.fetchAndSummarizeWagers;
const _svs$numbergames_rela = svs.numbergames_related.data,
  wagers = _svs$numbergames_rela.wagers,
  branding = _svs$numbergames_rela.branding;
const Icon = svs.ui.ReactIcon;
const PayConfirmation = () => {
  var _svs$utils$paramHandl, _svs$utils$paramHandl2, _svs$utils$paramHandl3, _svs$utils$paramHandl4, _svs$utils$paramHandl5, _svs$utils$paramHandl6;
  const wagerIds = (_svs$utils$paramHandl = (_svs$utils$paramHandl2 = svs.utils.paramHandler.get({
    key: 'wagerIds'
  })) === null || _svs$utils$paramHandl2 === void 0 ? void 0 : _svs$utils$paramHandl2.value) !== null && _svs$utils$paramHandl !== void 0 ? _svs$utils$paramHandl : (_svs$utils$paramHandl3 = svs.utils.paramHandler.get({
    key: 'wagerId'
  })) === null || _svs$utils$paramHandl3 === void 0 ? void 0 : _svs$utils$paramHandl3.value;
  const ticketAmount = (_svs$utils$paramHandl4 = svs.utils.paramHandler.get({
    key: 'tickets'
  })) === null || _svs$utils$paramHandl4 === void 0 ? void 0 : _svs$utils$paramHandl4.value;
  const ticketId = (_svs$utils$paramHandl5 = svs.utils.paramHandler.get({
    key: 'ticketId'
  })) === null || _svs$utils$paramHandl5 === void 0 ? void 0 : _svs$utils$paramHandl5.value;
  const partialPaymentFailed = (_svs$utils$paramHandl6 = svs.utils.paramHandler.get({
    key: 'partialPaymentFailed'
  })) === null || _svs$utils$paramHandl6 === void 0 ? void 0 : _svs$utils$paramHandl6.value;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    title = _useState2[0],
    setTitle = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    messages = _useState4[0],
    setMessages = _useState4[1];
  useEffect(() => {
    let isMounted = true;
    (async () => {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && wagerIds) {
        const result = await fetchAndSummarizeWagers({
          wagerIds,
          wagers,
          branding,
          ticketAmount: parseInt(ticketAmount, 10),
          ticketId,
          partialPaymentFailed
        });
        if (isMounted) {
          setTitle((result === null || result === void 0 ? void 0 : result.title) || "Ditt ".concat(branding, " \xE4r betalat! Lycka till!"));
          setMessages((result === null || result === void 0 ? void 0 : result.messages) || []);
          ['wagerIds', 'wagerId', 'tickets', 'ticketId', 'partialPaymentFailed'].forEach(key => svs.utils.paramHandler.remove({
            key
          }));
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [wagerIds, ticketAmount, ticketId, partialPaymentFailed]);
  if (!wagerIds || !title) {
    return null;
  }
  return React.createElement("div", {
    className: "pay-content js-pay-related-content f-content"
  }, React.createElement("div", {
    className: "".concat(branding, "-pay-confirm pay-confirmation-container align-center")
  }, React.createElement("span", {
    className: "icon"
  }, React.createElement(Icon, {
    icon: "thumbs-up",
    size: "900"
  })), React.createElement("h1", {
    className: "f-bold"
  }, title), React.createElement("div", {
    className: "messages"
  }, messages === null || messages === void 0 ? void 0 : messages.map((msg, idx) =>
  React.createElement("p", {
    key: "msg-".concat(idx)
  }, msg)))));
};
setGlobal('svs.numbergames_related.components', {
  PayConfirmation
});

 })(window);